// extracted by mini-css-extract-plugin
export default {"header":"reserve-capacity-header_header__Ov0+W","headerTitle":"reserve-capacity-header_headerTitle__uT0b2","headerSubtitle":"reserve-capacity-header_headerSubtitle__gyuDm"};